import React from 'react';
import styled, { css } from 'styled-components';
import { CommonText } from '../bumpViews/commonText';
import { FaCheck } from 'react-icons/fa';
const OptionItemWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid transparent;
  ${({ active, version, disabled }) => {
    if (disabled) {
        return css `
        background-color:  #DFDFDF;
      `;
    }
    else if (version === 'v2') {
        if (active) {
            return css `
        border: 1px solid #fb2f2f;
        background-color:  #FFF3F3;
      `;
        }
        return css `
      background-color: #F1F4F7;
    `;
    }
    else {
        if (active) {
            return css `
        border: 1px solid #fb2f2f;
        background:  #fff3f3;
      `;
        }
        return css `
      background: #f5f5f5;
    `;
    }
}}
`;
export const OptionItem = ({ id, text, isActive, onClick, version = 'v1', disabled = false }) => {
    return (React.createElement(OptionItemWrapper, { id: id, active: isActive, version: version, disabled: disabled, onClick: !disabled ? onClick : () => { } },
        React.createElement(CommonText, { size: "semiMedium", weight: 500, color: isActive ? '#FB2F2F' : '#4B4F5E' }, text),
        isActive && React.createElement(FaCheck, { color: isActive ? '#FB2F2F' : '#4B4F5E' })));
};
//# sourceMappingURL=index.js.map